import { useState } from 'react';
import { api } from '../lib/api';
import { applyTheme } from '../lib/theme';
import { OtterMark } from './OtterMark';
import type { PublicUser, ThemeId } from '@otter/shared';

declare const __APP_VERSION__: string;

type Props = {
  onLoggedIn: (user: PublicUser) => void;
};

export function Login({ onLoggedIn }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const res = await api<{ user: PublicUser; theme: ThemeId }>('/admin/auth/login', {
        method: 'POST',
        body: { email, password },
      });
      applyTheme(res.theme);
      onLoggedIn(res.user);
    } catch (e) {
      setErr((e as Error).message || 'Error de login');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <div className="brand">
          <OtterMark size={36} />
          <div className="nm">OTTER</div>
          <div className="v">v{__APP_VERSION__}</div>
        </div>
        <div className="hello">
          ~/otter/<b>login</b>
        </div>
        {err && <div className="err">{err}</div>}
        <div className="field">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            required
          />
        </div>
        <div className="field">
          <label>Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn primary" disabled={busy} style={{ justifyContent: 'center' }}>
          {busy ? 'entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
